import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  containerAccordion: theme.containerAccordion,
  containerPDIAccordion: theme.containerPDIAccordion,
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#dee8e8'
  },

  externalLayer: {
    minHeight: theme.spacing(5),
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid white'
  },

  boxIcon: {
    width: theme.spacing(2),
    marginRight: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },

  boxIconOption: {
    width: theme.spacing(4)
  },

  optionIcon: {
    width: theme.spacing(4),
    height: theme.spacing(4)
  },

  containerOption: {
    borderBottom: '1px solid white',
    display: 'flex',
    paddingLeft: theme.spacing(4),
    marginLeft: theme.spacing(3)
  },
  containerTitle: {
    display: 'grid',
    gridTemplateColumns: '10% 90%',
    width: '100%',
    alignItems: 'center'
  },

  optionName: {
    marginLeft: theme.spacing()
  }
}))
